import React, { ComponentType } from 'react'
import { Segment } from 'semantic-ui-react'
// Local
import { Encounter } from '../../authenticated/types'

const SafeSegment = Segment as unknown as ComponentType<any>

type Props = {
  mode?: string | undefined
  encounter: Encounter | undefined
}

function EncounterAppointment(
  props: Props
): JSX.Element | null {
  const {
    mode = 'left',
    encounter
  } = props

  const aptType = encounter && encounter.appointmentType
    ? encounter.appointmentType
    : <span className="italic">Unavailable</span>

  if (mode === 'left') {
    return (
      <SafeSegment
        attached
        compact
        className="left-segment"
      >
        <div className="left-title">
          Appointment Type:
        </div>
        <div className="left-content">
          { aptType }
        </div>
      </SafeSegment>
    )
  }
  return null
}

export default EncounterAppointment
